import type { FrontendRouterInputs } from '../routerInputs';

export type InsertIssueAssessmentInput =
  FrontendRouterInputs['issueAssessment']['insert'];
export type UpdateIssueAssessmentInput =
  FrontendRouterInputs['issueAssessment']['update'];

export const coerceToArray = (
  value: string | string[] | null | undefined
): string[] => (Array.isArray(value) ? value : value != null ? [value] : []);
